import { useEffect, useState } from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";

export const useContextValue = () => {
  const { isUpMd } = useMediaQuery();
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    setIsNavOpen(isUpMd);
  }, [isUpMd]);

  const openNav = () => setIsNavOpen(true);

  const closeNav = () => setIsNavOpen(false);

  return {
    isNavOpen,
    openNav,
    closeNav,
  };
};
